export default {
  communityId: null,
  calculatorType: null,
  formData: {},
  estimate: {}
}
